<template>
    <div>
        <img v-show="flag" :src="src">
        <img v-show="!flag" :src="placeImg" :class="{blur:mask && !flag}">
    </div>
</template>

<script>
    import headImg from "src/assets/image/head-img.svg"
    export default {
        props:{
            src:{
                type:String,
            },
            placeImg:{
                type:String,
                default:headImg,  //默认头像
            },
            mask:{  //添加遮罩
                type:Boolean,
                default:false,
            }
        },
        data(){
            return {
                flag:false,
            }
        },
        watch:{
            src(val){
                this.loadImg(val);
            }
        },
        created(){
            this.loadImg(this.src);
        },
        methods:{
            loadImg(src){
                let img = new Image();
                img.onload = ()=>{
                    this.flag = true;
                }
                img.src = src;
            }
        },
    }
</script>

<style lang="less" scoped>
    div{
        overflow: hidden;
    }
    img{
        height: 100%;
        width:100%;
    }
    .blur{
        filter: blur(5px);
    }
</style>





// WEBPACK FOOTER //
// lazyImg.vue?14adab88